'use client'

import { useMemo } from 'react'

import { useAuth } from '~/hooks/useAuth'
import { useCurrentOrgId } from '~/store/slices/currentOrg'

import type { BillingComposerSessionScope } from './pendingDraft'

/**
 * Organization + user identity for billing-composer sessionStorage keys. Returns null until both are
 * known so callers refuse to read or write an unscoped key rather than colliding across tenants.
 */
export default function useSessionScope(): BillingComposerSessionScope | null {
  const organizationId = useCurrentOrgId()
  const { user } = useAuth()
  return useMemo(() => {
    if (!organizationId || !user?.id) return null
    return { organizationId, userId: user.id }
  }, [organizationId, user?.id])
}
